import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Select, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"
import type { UserSearchParams } from "@/services/user/userApi"

interface UserSearchFormProps {
  onSearch: (values: Omit<UserSearchParams, "page" | "per_page">) => void
  loading?: boolean
  initialValues?: Omit<UserSearchParams, "page" | "per_page">
}

const UserSearchForm: React.FC<UserSearchFormProps> = memo(({ onSearch, loading = false, initialValues }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues)
    }
  }, [initialValues, form])

  const handleSearch = () => {
    form.validateFields().then((values) => {
      onSearch(values)
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: "",
      is_test: undefined,
      is_online: undefined,
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Card>
        <Form
          form={form}
          initialValues={{
            search: "",
            is_test: undefined,
            is_online: undefined,
          }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4"
        >
          <Form.Item name="search" label="Tài khoản" colon={false} className="mb-0">
            <Input
              allowClear
              autoComplete="off"
              placeholder="Tên, email, tài khoản hoặc #ID (VD: #:12, #12)..."
              onPressEnter={handleSearch}
            />
          </Form.Item>

          <Form.Item name="is_test" label="Phân loại" colon={false} className="mb-0">
            <Select
              allowClear
              placeholder="Tất cả tài khoản"
              onChange={handleSearch}
              options={[
                { label: "Tất cả tài khoản", value: undefined as any },
                { label: "👤 Người dùng thật", value: 0 },
                { label: "🧪 Tài khoản Test", value: 1 },
              ]}
            />
          </Form.Item>

          <Form.Item name="is_online" label="Trực tuyến" colon={false} className="mb-0">
            <Select
              allowClear
              placeholder="Tất cả trạng thái"
              onChange={handleSearch}
              options={[
                { label: "Tất cả trạng thái", value: undefined as any },
                { label: "🟢 Đang trực tuyến", value: "true" },
                { label: "⚪ Ngoại tuyến", value: "false" },
              ]}
            />
          </Form.Item>

          <Form.Item label=" " colon={false} className="mb-0">
            <Space>
              <Button type="default" icon={<RedoOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ConfigProvider>
  )
})

UserSearchForm.displayName = "UserSearchForm"

export default UserSearchForm
